import { IApiResponse, IFullRate } from "./models";

interface FrankfurterResponse {
    amount: number;
    base: string;
    date: string;
    rates: {
        [currency: string]: number;
    };
}

export async function getRates(): Promise<IApiResponse> {
    try {
        const [cadToEurResponse, eurToCadResponse] = await Promise.all([
            fetch('/api/rates?from=CAD&to=EUR'),
            fetch('/api/rates?from=EUR&to=CAD')
        ]);

        if (!cadToEurResponse.ok || !eurToCadResponse.ok) {
            throw new Error('Failed to fetch exchange rates');
        }

        const cadToEur: FrankfurterResponse = await cadToEurResponse.json();
        const eurToCad: FrankfurterResponse = await eurToCadResponse.json();

        const rates: IFullRate[] = [
            {
                currBuy: 'CAD',
                currSell: 'EUR',
                gateCode: 'FRANKFURTER',
                realRate: cadToEur.rates.EUR,
                customerRate: cadToEur.rates.EUR,
                isFrozen: false,
                gateBuy: 'FRANKFURTER',
                gateSell: 'FRANKFURTER',
                crossCurr: '',
                rateUpdateWarnSec: 3600,
                rateUpdated: new Date(cadToEur.date)
            },
            {
                currBuy: 'EUR',
                currSell: 'CAD',
                gateCode: 'FRANKFURTER',
                realRate: eurToCad.rates.CAD,
                customerRate: eurToCad.rates.CAD,
                isFrozen: false,
                gateBuy: 'FRANKFURTER',
                gateSell: 'FRANKFURTER',
                crossCurr: '',
                rateUpdateWarnSec: 3600,
                rateUpdated: new Date(eurToCad.date)
            }
        ];

        return {
            body: rates,
            errorCode: ''
        };
    } catch (error) {
        console.error('Error fetching rates from Frankfurter:', error);
        return {
            body: [],
            errorCode: 'FETCH_ERROR'
        };
    }
}
